<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- Loading indicator -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- No records message -->
  @if (noRecords && !loading) {
<div class="col-md-12">
    <span class="noRecords">No Records Found.</span>
  </div>
}

  <!-- Main content -->
  @if (!loading && !noRecords) {
<div>
    <div style="margin-top:15px">
      <div class="table-responsive" style="min-height: 200px;">
        <table class="table table-hover table-bordered table-striped table-condensed custom-table">
          <thead>
            <tr>
              <th>DOM GENERATED ON</th>
              <th>PDF FORM ERROR COUNT</th>
              <th>PDF GENERATED ON</th>
              <th>XML ZIP GENERATED ON</th>
              <th>DATA ERROR</th>
              <th>XML ZIP VALIDATION ERROR</th>
              <th>XML ZIP GENERATION ERROR</th>
              <th>UNEXPECTED ERROR</th>
            </tr>
          </thead>
          <tbody>
            @for (obj of sltDataGenerationData; track $index) {
<tr>
              <td>{{obj.DOM_GENERATED_ON}}</td>
              <td>{{obj.PDF_FORM_ERROR_COUNT}}</td>
              <td>{{obj.PDF_GENERATED_ON}}</td>
              <td>{{obj.XML_ZIP_GENERATED_ON}}</td>
              <td>{{obj.DATA_ERROR}}</td>
              <td>{{obj.XML_ZIP_VALIDATION_ERROR}}</td>
              <td>{{obj.XML_ZIP_GENERATION_ERROR}}</td>
              <td>{{obj.UNEXPECTED_ERROR}}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>

    <!-- No records in data array -->
    @if (sltDataGenerationData.length === 0) {
<div>
      <span class="noRecords">No Records Found.</span>
    </div>
}
  </div>
}

</div>

<!-- STANDARD Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
